// extracted by mini-css-extract-plugin
module.exports = {"row":"cardRow_row_lwlbT","mobileRow":"cardRow_mobileRow_38k2g"};